const getChild = require("../dom/getChild");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {HTMLSelectElement}
 */
module.exports = function getPreferenceCenterCountrySelect(preferenceCenter) {
    return getChild(preferenceCenter, '[name="country"]');
}
